import React, {Component} from 'react'
import PrintPreview from './PrintPreview'
import PdfStore from '../../stores/PdfStore'

const DEFAULT_ITEM_PER_PAGE = 20
class PrintReceptionDoc extends Component {

  constructor(...args){
    super(...args)
    this.state = {
      loading:false,
      report_title:'กำลังดึงข้อมูล..',
      itemPerPage:DEFAULT_ITEM_PER_PAGE,
      allData: [],
      data: {
        attorney:'',
        company_addr:'',
        company_fax:'',
        company_name:'',
        company_tax:'',
        company_tel:'',
        logo_class:'',
        logo_height:'',
        logo_url:'',
        logo_width:'',
        org_id:'',
        doc:{},
        itemlist:[]
      }
    }

    var cssPagedMedia = (function() {
      var style = document.createElement('style');
      document.head.appendChild(style);
      return function (rule) {
        style.innerHTML = rule;
      };
    }());

    cssPagedMedia.size = function(size) {
      cssPagedMedia('@page {size: ' + size + '}');
    };
    cssPagedMedia.size('portrait');
  }

  componentDidMount(){
    this.loadData(this.state.itemPerPage)
  }

  getEmptyDoc(){
    return {
      added_date:'',
      car_registration_no:'',
      deliveryslip_no:'',
      department:'',
      description:'',
      purchase_order_no:'',
      reception_by:'',
      reception_no:'',
      remark:'',
      response_by:'',
      seq_no:'',
      status:'0',
      taxinvoice_no:'0',
      userid:'0',
      work_no:'',
      shop_name:'',
      shop_id:''
    }
  }

  loadData(itemPerPage) {
    let {allData,data} = this.state
    PdfStore.loadReceptionDoc(this.props.rcNo,(result)=> {
      if (typeof result.data.doc==='undefined')
        data = Object.assign(result.data,{doc:this.getEmptyDoc()})
      if (typeof result.data.itemlist==='undefined')
        data = Object.assign(result.data,{itemlist:[]})
      else
        data = result.data

      allData = this.getPagination(data,itemPerPage)
      this.setState({data:data,allData:allData,report_title:'ไม่พบข้อมูล'})
    })  
  }

  renderLogoUrl(logoUrl){
    if(logoUrl===undefined){
      return ('')
    }
    let imgUrl = ''
    if (process.env.NODE_ENV == "development") {
      imgUrl = 'https://demo2.bigfix.co/korat/pdf/'+logoUrl
    }else{
      imgUrl = '../'+logoUrl
    }
    return (<img src={imgUrl} style={{maxWidth:'100px'}}/>)
  }

  renderRowData(items,page=0) {
    if (items.length===0) {
      return(<tr><td colSpan={6}>ไม่พบข้อมูล</td></tr>)
    } else {
      return(
        items.map((item,index) => {
          let number = 0
          if (page===0)
            number = (index*1)+1
          else
            number = ((page*this.state.itemPerPage)*1)+(index*1)+1
          
          return(
            <tr key={index} className={index>0?'n-b':''}>
              <td className='text-center'>{number}</td>
              <td className='text-center'>{item.productcode}</td>
              <td>{item.detail}</td>
              <td className='text-center'>{item.quantity}</td>
              <td className='text-right'>{this.getNumberFormat(item.price_per_unit)}</td>
              <td className='text-right'>{this.getNumberFormat(item.amount)}</td>
            </tr>
          )
        })
      )
    }
  }

  getNumberFormat(value) {
    let _val = value===''||value===null||value===undefined||isNaN(value) ? 0 : value*1
    if (_val===0)
      return 0
    _val = parseFloat(_val)
    return _val.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
  }

  renderFooter() {
    let {data} = this.state
    let sumQty = 0, sumAmount = 0
    data.itemlist.forEach(function(item,index) {
      let quantity = item.quantity  
      if (quantity===''||quantity===null||quantity===undefined||isNaN(quantity)) {
        quantity = 0
      }
      sumQty += parseFloat(quantity)
      sumAmount += parseFloat(item.amount)
    })
    return(
      <tr>
        <td colSpan={3}>รวมรายการ</td>
        <td className='text-center'>{sumQty}</td>
        <td className='text-center'></td>
        <td className='text-right'>{this.getNumberFormat(sumAmount)}</td>
      </tr>
    )
  }

  renderSignature() {
    return(
      <table className='table table-header-print-po-received-doc'>
        <tbody>
          <tr>
            <td className='text-center' style={{width:'50%'}}>..................................................................</td>
            <td className='text-center' style={{width:'50%'}}>..................................................................</td>
          </tr>
          <tr>
            <td className='text-center' style={{width:'50%'}}>ลงชื่อผู้รับของ</td>
            <td className='text-center' style={{width:'50%'}}>ผู้อนุมัติ</td>
          </tr>
          <tr>
            <td className='text-center' style={{width:'50%'}}>วันที่ ............./....................../........................</td>
            <td className='text-center' style={{width:'50%'}}>วันที่ ............/...................../...........................</td>
          </tr>
        </tbody>
      </table>    
    )
  }

  renderTable(item,index,length) {
     return(
      <div className=''>
        <table className='table table-print-po-received-doc'>
          <tbody>
            <tr>
              <td className='text-center' style={{width:'50px'}}>ลำดับ</td>
              <td className='text-center' style={{width:'100px'}}>รหัสสินค้า</td>
              <td className='text-center' style={{width:'300px'}}>รายการ</td>
              <td className='text-center' style={{width:'70px'}}>จำนวน</td>
              <td className='text-center' style={{width:'70px'}}>ราคาต่อหน่วย</td>
              <td className='text-center' style={{width:'70px'}}>จำนวนเงิน</td>
            </tr>
            {this.renderRowData(item,index)}
            {length===index?this.renderFooter():''}
          </tbody>  
        </table>
        <div className='footer-page'>
          {length===index?this.renderSignature():''}
        </div>  
      </div>
    )      
  }

  renderHeader() {
    let item = this.state.data.doc
    return(
      <div>
          <table className='table table-header-print-po-received-doc'>
            <tbody>
              <tr>
                <td style={{width:'100px'}}>เลขที่ใบรับของ :</td>
                <td>{this.props.rcNo}</td>
                <td className='text-right'>วันที่ :</td>
                <td style={{width:'120px'}} className='text-right'>{item.added_date}</td>
              </tr>
              <tr>
                <td>ผู้รับสินค้า :</td>
                <td>{item.reception_by}</td>
                <td className='text-right'>ผู้อนุมัติ :</td>
                <td className='text-right'>{item.response_by}</td>
              </tr>
              <tr>
                <td>ชื่อร้าน :</td>
                <td>{item.shop_name===''||item.shop_name===null||item.shop_name===undefined?'':item.shop_name}</td>
                <td className='text-right'>ทะเบียนรถ :</td>
                <td className='text-right'>{item.car_registration_no===''||item.car_registration_no===null||item.car_registration_no===undefined?'':item.car_registration_no}</td>
              </tr>
              <tr>
                <td>เลขที่ใบส่งของ :</td>
                <td>{item.deliveryslip_no}</td>
                <td className='text-right'>เลขที่ใบกำกับ :</td>
                <td className='text-right'>{item.taxinvoice_no}</td>
              </tr>
              <tr>
                <td>คำอธิบาย :</td>
                <td>{item.description}</td>
              </tr>
            </tbody>
          </table>
      </div>
    )
  }

  renderComponentPage(item,index,length) {
    let {data} = this.state
    const title = this.props.title
    return(
      <div className='font-print' key={index}>
        <div>
          <header>
            <h2>{title}</h2>
          </header>
          <article className={"article-company "+data.logo_class}>
            <div style={{width:data.logo_width+'px',textAlign:'center',lineHeight:'70px'}}>
              {this.renderLogoUrl(data.logo_url)}
            </div>
            <section className="font-18" style={{paddingTop:(data.logo_class=='bg-logo-absolute'?'0px':'0')}}>
            <strong>
              <p style={{lineHeight:'0.7'}}>{data.company_name} ({data.company_branch})</p>
              <p style={{lineHeight:'0.7'}}>{data.company_addr} </p>
              <p style={{lineHeight:'0.7'}}>โทร {data.company_tel} โทรสาร {data.company_fax}</p>
            </strong>
          </section>
          </article>
        </div>
        <div>
          {this.renderHeader()}
          {this.renderTable(item,index,length)}
        </div>
      </div>  
    )
  }

  getPagination(data,itemPerPage) {
    let newData = []
    let allData = []
    let checkRow = 0
    if (data.itemlist.length===0)
      return([[]])
      
    data.itemlist.forEach(function(item,index) {
        if (checkRow<itemPerPage)
          checkRow++
          newData.push(item)

        if (checkRow===itemPerPage-1||index===data.itemlist.length-1) {
          allData.push(newData)
          checkRow = 0
          newData = []
        }
    })  
    return allData
  }

  onRowsPerPageChange(itemPerPage) {
    this.setState({itemPerPage:itemPerPage})
    this.loadData(itemPerPage)
  }

  renderNoData() {
    return(
      <div className='font-print'>
        <header className="text-center">
          <h2>{this.state.report_title}</h2>
        </header>
      </div>
    )
  }

  render() {
    let {loading,allData} = this.state
    if (allData.length===0) {
      return(
        <PrintPreview 
          loading={loading}
          leftBarTitle={this.props.title+' '+this.props.rcNo}
        >
          {this.renderNoData()}
        </PrintPreview>
      )  
    } else {
      return(
        <PrintPreview 
          loading={loading}
          leftBarTitle={this.props.title+' '+this.props.rcNo}
          defaultRowPerPage={DEFAULT_ITEM_PER_PAGE}
          startRowPerPage={10}
          endRowPerPage={20}
          onRowsPerPageChange={this.onRowsPerPageChange.bind(this)}
        >
          {
            allData.map((item,index) => {
              return(
                this.renderComponentPage(item,index,allData.length-1)
              )
            })
          }
        </PrintPreview>
      )
    }  
  }

}  

PrintReceptionDoc.defaultProps = {
  title: 'ใบรับของ/สินค้า/อะไหล่',  
  mode : '1'
}
export default PrintReceptionDoc;


// WEBPACK FOOTER //
// ./src/view/print/PrintReceptionDoc.js